module.exports = __webpack_public_path__ + "img/user.b8982e19.png";